import CustomButton from "../../components/CustomButton/Button";
import CustomModal from "../../components/CustomModal/CustomModal";
import { Result } from "antd";
import { GLOBAL_CONSTANTS, BTN_TXT } from "../../constants/constants";

const KycSuccessModal = ({
    isModalVisible,
    setIsModalVisible,
    userDetailsLoading,
    handleProceed,
}) => {
    return (
        <CustomModal
            open={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            closable={false}
            maskClosable={false}
            centered
            content={
                <>
                    <Result
                        status={GLOBAL_CONSTANTS.SUCCESS}
                        title={GLOBAL_CONSTANTS.KYC_SUCCESS_MSG}
                        extra={[
                            <CustomButton
                                loading={userDetailsLoading}
                                type="primary"
                                onClick={handleProceed}
                            >
                                {BTN_TXT.PROCEED_FURTHER}
                            </CustomButton>,
                        ]}
                    />
                </>
            }
        />
    );
};

export default KycSuccessModal;
